import $ from 'jquery'

/* global filterOptgroupOptions, refreshTomSelect -- exposed by tom-select.js */

// Location_type
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectLocationType = $('.select_location_type')
  const selectEstateGroup = $('.select_estate')
  const selectEstate = $('.select_location_estate')
  const selectBuildingGroup = $('.select_building')
  const selectBuilding = $('.select_location_building')
  const selectFloorGroup = $('.select_floor')
  const selectFloor = $('.select_location_floor')
  const selectRoomGroup = $('.select_room')
  const selectRoom = $('.select_location_room')
  const inputRoomNameGroup = $('.input_room_name')
  const inputRoomName = $('.select_location_room_name')
  const selectVehicleGroup = $('.select_vehicle')
  const selectVehicle = $('.select_location_vehicle')
  const selectEquipmentGroup = $('.select_equipment')
  const selectEquipment = $('.select_location_equipment')
  const managedByCascade = selectEstate.first().closest('[data-cascade]').length > 0

  // The select tag last in a certain cascade, for example when we set 'Floor' as location_type, needs a certain name the be valid and get recoginized within the params hash. As this script is used for in different places, QrCode form, Maintenance record form, etc., we extract it from a hidden field within select_location.html
  const activeSelectLocationIdName = $('#active_select_location_id_name').attr('name')

  selectLocationType.off('change.selectLocationType').on('change.selectLocationType', () => {
    // First disable everything and show only selectEstateGroup
    selectEstateGroup.removeClass('d-none')
    selectEstate.attr('name', 'disabled')
    selectBuildingGroup.addClass('d-none')
    selectBuilding.attr('name', 'disabled')
    selectFloorGroup.addClass('d-none')
    selectFloor.attr('name', 'disabled')
    selectRoomGroup.addClass('d-none')
    selectRoom.attr('name', 'disabled')
    inputRoomNameGroup.addClass('d-none')
    inputRoomName.attr('disabled', true)
    selectVehicleGroup.addClass('d-none')
    selectVehicle.attr('name', 'disabled')
    selectEquipmentGroup.addClass('d-none')
    selectEquipment.attr('name', 'disabled')
    // … then enable conditionally
    switch (selectLocationType.val()) {
      case 'Estate':
        selectEstate.attr('name', activeSelectLocationIdName)
        break
      case 'Building':
        selectBuildingGroup.removeClass('d-none')
        selectBuilding.attr('name', activeSelectLocationIdName)
        break
      case 'Floor':
        selectBuildingGroup.removeClass('d-none')
        selectFloorGroup.removeClass('d-none')
        selectFloor.attr('name', activeSelectLocationIdName)
        inputRoomNameGroup.removeClass('d-none')
        inputRoomName.attr('disabled', false)
        break
      case 'Room':
        selectBuildingGroup.removeClass('d-none')
        selectFloorGroup.removeClass('d-none')
        selectRoomGroup.removeClass('d-none')
        selectRoom.attr('name', activeSelectLocationIdName)
        break
      case 'Vehicle':
        selectEstateGroup.addClass('d-none')
        selectVehicleGroup.removeClass('d-none')
        selectVehicle.attr('name', activeSelectLocationIdName)
        break
      case 'Equipment':
        selectEstateGroup.addClass('d-none')
        selectEquipmentGroup.removeClass('d-none')
        selectEquipment.attr('name', activeSelectLocationIdName)
        break
    }
  })

  // IMPORTANT
  // Also trigger everything after page (re)load, e.g. validation fail
  selectLocationType.trigger('change')

  if (managedByCascade) return

  // Location id
  // -------------------------------------------------------------------

  // Destroy Tom Select on cascading selects so we can capture the raw server-rendered
  // <option>/<optgroup> HTML. refreshTomSelect() will re-init them after each cascade.
  for (const el of [selectBuilding, selectFloor, selectRoom]) {
    if (el[0]?.tomselect) el[0].tomselect.destroy()
  }

  const buildings = selectBuilding.html()
  const floors = selectFloor.html()
  const rooms = selectRoom.html()

  const emptyOption = "<option value='' selected='selected'></option>"

  // Disable secondary/tertiary selects of cascades
  if (selectEstate.val() === '') selectBuilding.prop('disabled', true)
  if (selectBuilding.val() === '') selectFloor.prop('disabled', true)
  if (selectFloor.val() === '') selectRoom.prop('disabled', true)

  // Populate buildings
  let selectedBuilding = selectBuilding.find('option:selected').val()
  selectEstate.off('change.selectLocationCascade').on('change.selectLocationCascade', () => {
    const selectedEstate = selectEstate.val()
    const selectedEstateLabel = selectEstate.find('option:selected').text()

    const options = filterOptgroupOptions(buildings, selectedEstate, selectedEstateLabel, selectEstate[0]?.selectedIndex)
    if (options) {
      selectBuilding.prop('disabled', false)
      selectBuilding.html(options)
      if (selectBuilding.val() === '') selectFloor.prop('disabled', true)
      if (selectFloor.val() === '') selectRoom.prop('disabled', true)
      // Auto-select if there is only one building
      if (selectBuilding.children('option').length === 2) selectBuilding[0].selectedIndex = 1
    } else {
      selectBuilding.prop('disabled', true)
      selectBuilding.html(emptyOption)
    }
    if (selectBuilding.find('option:first-child').val() !== '') selectBuilding.prepend(emptyOption)
    if (!(selectedBuilding > 0 || selectBuilding.children('option').length === 2)) selectBuilding[0].selectedIndex = 0
    refreshTomSelect(selectBuilding)
    populateSelectFloors()
    selectBuilding.trigger('change')
  })

  // Populate floors
  let selectedFloor = selectFloor.find('option:selected').val()
  selectBuilding.off('change.selectLocationCascade').on('change.selectLocationCascade', () => {
    selectedBuilding = selectBuilding.find('option:selected').val()
    populateSelectFloors()
  })

  const populateSelectFloors = () => {
    const selectedBuildingLabel = selectBuilding.find('option:selected').text()
    const options = filterOptgroupOptions(floors, selectedBuilding, selectedBuildingLabel, selectBuilding[0]?.selectedIndex)
    if (options) {
      selectFloor.prop('disabled', false)
      selectFloor.html(options)
      if (selectFloor.val() === '') selectRoom.prop('disabled', true)
      // Auto-select if there is only one floor
      if (selectFloor.children('option').length === 2) selectFloor[0].selectedIndex = 1
    } else {
      selectFloor.prop('disabled', true)
      selectFloor.html(emptyOption)
    }
    if (selectFloor.find('option:first-child').val() !== '') selectFloor.prepend(emptyOption)
    if (!(selectedFloor > 0 || selectFloor.children('option').length === 2)) selectFloor[0].selectedIndex = 0
    refreshTomSelect(selectFloor)
    populateSelectRooms()
    setTimeout(() => selectFloor.trigger('change'), 100)
  }

  // Populate rooms
  const selectedRoom = selectRoom.find('option:selected').val()
  selectFloor.off('change.selectLocationCascade').on('change.selectLocationCascade', () => {
    selectedFloor = selectFloor.find('option:selected').val()
    populateSelectRooms()
  })

  const populateSelectRooms = () => {
    const selectedFloorLabel = selectFloor.find('option:selected').text()
    const options = filterOptgroupOptions(rooms, selectedFloor, selectedFloorLabel, selectFloor[0]?.selectedIndex)
    if (options) {
      selectRoom.prop('disabled', false)
      selectRoom.html(options)
    } else {
      // Disabled, with only the empty option
      selectRoom.prop('disabled', true)
      selectRoom.html(emptyOption)
    }
    if (selectRoom.find('option:first-child').val() !== '') selectRoom.prepend(emptyOption)
    if (!(selectedRoom > 0)) selectRoom[0].selectedIndex = 0
    refreshTomSelect(selectRoom)
    setTimeout(() => {
      if (selectRoom.children('option').length === 2) {
        selectRoom[0].selectedIndex = 1
        selectRoom.trigger('change')
      }
    }, 100)
  }
})
